/**
 * The heading components
 */
import * as React from 'react';
import { colors, fontSizes, fontFamily } from './styles';
import * as typestyle from 'typestyle';

export namespace HeadingStyles {
  export const heading1 = {
    fontFamily: fontFamily.auspost,
    color: colors.headingColor,
    fontSize: fontSizes.h1,
    lineHeight: fontSizes.apLineHeight,
  }

  export const heading2 = {
    fontFamily: fontFamily.auspost,
    color: colors.headingColor,
    fontSize: fontSizes.h2,
    lineHeight: fontSizes.apLineHeight,
  }

  export const heading3 = {
    fontFamily: fontFamily.auspost,
    color: colors.headingColor,
    fontSize: fontSizes.h3,
    lineHeight: fontSizes.apLineHeight,
  }

  export const heading4 = {
    fontFamily: fontFamily.auspost,
    color: colors.headingColor,
    fontSize: fontSizes.h4,
    lineHeight: fontSizes.apLineHeight,
  }

  export const heading5 = {
    fontFamily: fontFamily.auspost,
    color: colors.headingColor,
    fontSize: fontSizes.h5,
    lineHeight: fontSizes.apLineHeight,
  }

  export const heading6 = {
    fontFamily: fontFamily.auspost,
    color: colors.headingColor,
    fontSize: fontSizes.h6,
    lineHeight: fontSizes.apLineHeight,
  }

  export const paragraphClass = typestyle.style({
    color: colors.textColor,
    fontFamily: fontFamily.arial,
    fontSize: fontSizes.paragraph,
    margin: '0px',
    lineHeight: '25px',
  })

  export const ulClass = typestyle.style({
    color: colors.textColor,
    fontFamily: fontFamily.arial,
    fontSize: fontSizes.paragraph,
    margin: '0px',
    lineHeight: '25px',

    paddingLeft: '0px',

    $nest: {
      /** Fix margin on children */
      '&>*': {
        marginLeft: '17px !important'
      }
    }
  })

  export const paragraphInline = {
    /** Do not make it inline block as it breaks away from previous stuff */
    display: 'inline',
    color: colors.textColor,
    fontFamily: fontFamily.arial,
    fontSize: fontSizes.paragraph,
    margin: '0px',
    lineHeight: '25px',
  }

  export const strongText = {
    /** Do not make it inline block as it breaks away from previous stuff */
    display: 'inline',
    color: colors.headingColor,
    fontFamily: fontFamily.arial,
    fontSize: fontSizes.paragraph,
    margin: '0px',
    lineHeight: '25px',
    fontWeight: 'bold' as 'bold'
  }

  export const paragraphHeading = {
    color: colors.headingColor,
    fontSize: fontSizes.paragraph,
    fontFamily: fontFamily.arial,
  }

  export const smallText = {
    color: colors.textColor,
    fontFamily: fontFamily.arial,
    fontSize: fontSizes.smallText
  }
}

export interface HeadingProps {
  text: string;
  id?: string;
}

export const Heading1 = (props: HeadingProps) => {
  return <div id={props.id} style={HeadingStyles.heading1}>{props.text}</div>
}

export const Heading2 = (props: HeadingProps) => {
  return <div id={props.id} style={HeadingStyles.heading2}>{props.text}</div>
}

export const Heading3 = (props: HeadingProps) => {
  return <div id={props.id} style={HeadingStyles.heading3}>{props.text}</div>
}

export const Heading4 = (props: HeadingProps) => {
  return <div id={props.id} style={HeadingStyles.heading4}>{props.text}</div>
}

export const Heading5 = (props: HeadingProps) => {
  return <div id={props.id} style={HeadingStyles.heading5}>{props.text}</div>
}

export const Heading6 = (props: HeadingProps) => {
  return <div id={props.id} style={HeadingStyles.heading6}>{props.text}</div>
}

//////////////////////
// Paragrph styles
//////////////////////

/**
 * Just lays out a div with nice auspost text defaults
 */
export const Paragraph = (props: { children?: React.ReactNode, id?: string }) => {
  return <p id={props.id} className={HeadingStyles.paragraphClass}>{props.children}</p>
}

export const ParagraphInline = (props: { children?: React.ReactNode }) => {
  return <span style={HeadingStyles.paragraphInline}>{props.children}</span>
}


/** Put this on top of a paragraph as its heading */
export const ParagraphHeading = (props: { children?: React.ReactNode }) => {
  return <span style={HeadingStyles.paragraphHeading}>{props.children}</span>
}

/** Put this inside a paragraph for strong words */
export const StrongText = (props: { children?: React.ReactNode }) => {
  return <span style={HeadingStyles.strongText}>{props.children}</span>
}

/**
 * Some minor styling for a UL
 */
export const Ul = (props: { children?: React.ReactNode }) => {
  return <ul className={HeadingStyles.ulClass}>{props.children}</ul>
}

export const SmallText = (props: { children?: React.ReactNode }) => {
  return <div style={HeadingStyles.smallText}>{props.children}</div>
}
